export default "__VITE_ASSET__4f56e542__"